import React, {Component} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {TableCellTypes} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {inject, observer} from "mobx-react";
import {RouteComponentProps} from "react-router";
import {IUsersStore} from "../../mobx-store/storeInterfaces/usersInterface";


interface IProps extends RouteComponentProps {
    usersStore: IUsersStore;
}

@inject('usersStore')
@observer
class UsersScreen extends Component<IProps> {
    tableHeader: any = [];
    tableData: any[] = [];
    tableCellTypes: TableCellTypes[] = [];
    title: string;

    constructor(props: IProps) {
        super(props);
        this.title = 'Users';
    }

    getAdsTableHeader = () => {
        return [
            {
                title: 'User Name',
            },
            {
                title: 'User Email',
            },
            {
                title: 'User Phone',
            },
            {
                title: 'User Address',
            }
        ];
    };


    getAdsTableCellTypes = (): TableCellTypes[] => {
        return [
            {
                cellType: 'Text',
                key: 'name',
            },
            {
                cellType: 'Text',
                key: 'email',
            },
            {
                cellType: 'Text',
                key: 'phoneNumber',
            },
            {
                cellType: 'Text',
                key: 'address',
            },
        ];
    };

    render() {
        const {users, loaded} = this.props.usersStore;
        this.tableHeader = this.getAdsTableHeader();
        this.tableData = users;
        this.tableCellTypes = this.getAdsTableCellTypes();
        return loaded && (
            <div>
                <GeneralTableComponent emptyMessage='There are no users added yet'
                                       title={this.title}
                                       tableHeader={this.tableHeader}
                                       tableData={this.tableData}
                                       tableCellTypes={this.tableCellTypes}
                                       addButton={undefined}/>
            </div>
        );
    }

    componentDidMount() {
        this.props.usersStore.getUsers();
    }

}

export default UsersScreen;
